import { render, staticRenderFns } from "./contracts-companies.vue?vue&type=template&id=6a7684b0"
import script from "./contracts-companies.vue?vue&type=script&lang=js"
export * from "./contracts-companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports